(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_content-without-appearance"] && !Shopify.designMode) return;
  try {
    (() => {
  // Prevent double-init across sections/theme editor
  if (window.__mwcRevealInit) return;
  window.__mwcRevealInit = true;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const setIndex = (el, i) => {
    if (!el) return;
    el.setAttribute('data-mwc-anim-item', 'true');
    el.style.setProperty('--i', i);
  };

  const initOne = (wrap) => {
    if (!wrap || wrap.dataset.mwcBound === 'true') return;
    wrap.dataset.mwcBound = 'true';

    // Collect items to stagger (simple & safe)
    const heading = wrap.querySelector('h1, h2, h3');
    const text = wrap.querySelector('p');
    const buttons = Array.from(wrap.querySelectorAll('a.button, button, .button, [role="button"]'));
    const images = Array.from(wrap.querySelectorAll('img'));

    let idx = 0;
    setIndex(heading, idx++);
    setIndex(text, idx++);
    buttons.slice(0, 3).forEach((el) => setIndex(el, idx++));
    images.slice(0, 6).forEach((el) => setIndex(el, idx++));

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        wrap.classList.add('is-visible');
        io.unobserve(wrap);
      });
    }, { threshold: 0.25 });

    io.observe(wrap);
  };

  const scan = () => {
    document.querySelectorAll('.mwc-reveal').forEach(initOne);
  };

  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:reorder', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
